import Reveal from "./Reveal";
import CtaButton from "./CtaButton";

export default function CtaBand({
  title = "Want to see what your new site could look like?",
  buttonLabel = "Get a Free Preview",
  testId = "cta-band-button",
}) {
  return (
    <section className="relative overflow-hidden bg-navy" data-testid="cta-band">
      <svg
        className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.16]"
        aria-hidden="true"
        viewBox="0 0 1200 300"
        fill="none"
        preserveAspectRatio="none"
      >
        <path
          d="M-20 240 C 240 120, 420 300, 640 170 S 1040 60, 1220 120"
          stroke="#2D8CFF"
          strokeWidth="2"
          strokeDasharray="8 10"
        />
      </svg>
      <div className="relative mx-auto max-w-4xl px-4 py-20 text-center sm:px-6">
        <Reveal>
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
            {title}
          </h2>
          <div className="mt-8">
            <CtaButton to="/contact" testId={testId}>
              {buttonLabel}
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
